const { default: push } = require("../../datalayer/utils/push");

$('[class*="download-button"], [class*="view-button"]').click((e) => {
  const href = e.target.href;
  if(href) {
    const fileName = (href).substring((href).lastIndexOf('/')+1);
    push({'event': 'downloadEvent', 'file': fileName});
  }
});